// Packages
import PropTypes from 'prop-types';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';


// Components
import BTDSkeleton from 'components/BTDUI/BTDSkeleton';
import Currency from 'components/BTDUI/Currency';
import BTDButton from 'components/BTDUI/BTDButton';

// Other
import './styles.css'
import useApi from 'hooks/useApi';

const BookingListItem = ({ contact_name, created_at, id, isLoading, onChange, status, total, trading_name, }) => {

	const { post: restore } = useApi('/orders/restore', false);

	dayjs.extend(advancedFormat);

	return (
		<>
		<div className="BookingListItem">

			<div className='BookingListItem__date'>
				<p className='blue'>{! isLoading ? '#' + id : <BTDSkeleton />}</p>
				<p className='blue opacity'>{! isLoading ? dayjs(created_at).format('D MMM YYYY') : ''}</p>
			</div>

			<p className='blue'><span className='BookingListItem__label semi-bold'>Name: </span>{! isLoading ? contact_name : <BTDSkeleton />}</p>
			<p className='blue'><span className='BookingListItem__label semi-bold'>Organisation: </span>{! isLoading ? trading_name : <BTDSkeleton />}</p>
			<p className='blue right'>{! isLoading ? <Currency value={total} /> : <BTDSkeleton />}</p>
			{parseInt(id) < 478 ?
				<p className="red centre">Contact BTD</p>
			:
				<BTDButton
					label='Restore'
					className='BookingListItem__button'
					onClick={() => {
						if(window.confirm('Are you sure you want to restore this booking?')) {
							restore({id: id}, 'Booking restored!').then(() => {
								onChange();
							})
						}					
					}}
					size='small'
					style={{margin: '0 0 0 auto'}}
				/>
			}


		</div>

		</>
	)
}

BookingListItem.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isLoading: PropTypes.bool,
	name: PropTypes.string,
	onChange: PropTypes.func,
}

BookingListItem.defaultProps = {
	id: null,
	isLoading: false,
	name: null,
	onChange: () => {'onChange is not set!'},
}

export default BookingListItem;